import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jaimin Savaliya",
  title: "Hi there, I'm Jaimin",
  subTitle: emoji(
    "Passionate about engineering."
  ),
  subTitle2: emoji(
    "I'm inspired by applications that solve frustrations—from my own gym timing app that automates workout tracking, to transformative tools like Vercel that deploys entire websites with a single git push. The best software doesn't just add features—it removes friction."
  ),
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jaiminsavaliya316",
  linkedin: "https://www.linkedin.com/in/jaimin-savaliya",
  email: "savaliya.ja@northeastern.edu",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "Develop highly interactive Front end and robus backend for your software"
    ),
    emoji("Integrate Artificial Intelligence into software for automation, optimized workflow and improved user experience"),
    emoji(
      "Integration of third party services for smoother scalability"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: ".NET",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "Blazor",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Scikit-Learn",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "YOLO",
      fontAwesomeClassname: "fas fa-eye"
    },
    {
      skillName: "OpenCV",
      fontAwesomeClassname: "fas fa-camera"
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "Postman",
      fontAwesomeClassname: "fas fa-rocket"
    },
    {
      skillName: "Azure DevOps",
      fontAwesomeClassname: "fab fa-microsoft"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Northeastern University",
      logo: require("./assets/images/NU_RGB_seal_R.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "January 2024 - Apr 2026",
      // desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Contributed on amazing projects with students as well as external clients",
        "Learned best industry practices for robust and scalable developemet",
        "Made good friends and valuable connections"
      ]
    },
    {
      schoolName: "LDRP Institute of Technology and Research",
      logo: require("./assets/images/It_is_logo_of_LDRP.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2019 - April 2023",
      // desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems",
      descBullets: [
        "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems",
        "Mastered key programming languages, frameworks, and software engineering principles",
        "Participated in coding challenges and sharpen problem-solving and teamwork skills"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Python", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Software Development",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Bangor Savings Bank",
      companylogo: require("./assets/images/BSB_Logo.png"),
      date: "Jul. 2025 – Dec. 2025",
      descBullets: [
        "Participated in software engineering ceremonies for Agile development using SCRUM methodology, contributing to sprint planning, daily standups, peer reviews, and retrospectives",
        "Prototyped an AI application for proof of concept that verifies usefulness of AI at managerial decision-making by utilizing SML, Phi-4 and minimal .NET Web API"
      ]
      
    },
    {
      role: "Teaching Assistant - Artificial Intelligence",
      company: "Northeastern University",
      companylogo: require("./assets/images/NU_RGB_seal_R.png"),
      date: "Sep. 2024 – Dec. 2024",
      descBullets: [
        "Helped student learning in AI course by solving doubts, clarifying key concepts, and providing guidance on AI and ML techniques",
        "Learned various problem-solving approches from Master's students with diverse background"
      ]
      
    },
    {
      role: "Software Engineer",
      company: "TechnologiesNinja",
      companylogo: require("./assets/images/technologies_ninja_logo.jpeg"),
      date: "June 2022 – Oct. 2023",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Solved redundant development problem by introducing automation in development",
        "Collaborated with a team from non-technical department for continuous testing and debugging web application",
      ]
    },
    // {
    //   role: "Software Engineer Intern",
    //   company: "TechnologiesNinja",
    //   companylogo: require("./assets/images/technologies_ninja_logo.jpeg"),
    //   date: "May 2022 – June 2022",
    //   descBullets: [
    //     "Worked with highly talented, experienced software engineers to learn and develope production level APIs",
    //     "Gained experience of Agile methodologies and industry standarads"
    //   ]
    // },
  ]
};


const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Click on project title to view code repository 🐈‍⬛",
  projects: [
    {
      projectName: "Kambaz",
      projectDesc: "I built this to avoid doing actual work on Canvas. But then it became actual work. The irony is not lost on me.",
      descBullets: [
        "Tech Stack: React, Vite, TypeScript, Express.js Node, Netlify, Render, MongoDB",
      ],
      images: [
        require("./assets/images/Kambaz_2_dashboard.png"),
        require("./assets/images/Kambaz_3_assignment_views.png"),
        require("./assets/images/Kambaz_3_course_view.png"),
        require("./assets/images/Kambaz_5_assignment_crud.png"),
      ],
      gitlink: "https://github.com/jaiminsavaliya316/kambaz-jaimin",
      footerLink: []
    },
    {
      projectName: "Movie Review System",
      projectDesc: "Why IMDB when you have TMBD API? browse, add review and judge your friends' taste based on their favorite movie list.",
      descBullets: [
        "Tech Stack: Netlify, Render, MongoDB Atlas, React, Vite, TypeScript, Express.js Node",
      ],
      images: [
        require("./assets/images/movie_home_screen.png"),
        require("./assets/images/movie_home_screen_fav.png"),
        require("./assets/images/movie_page_with_cast.png"),
        require("./assets/images/movie_search_screen.png"),
        require("./assets/images/movie_other_u_profile.png"),
      ],
      gitlink: "https://github.com/jaiminsavaliya316/server-cs5610-final-project",
      footerLink: []
    },
    {
      projectName: "POCAI",
      projectDesc: "Developed an AI application prototype for proof-of-concept to test innovation idea which would allow company to make smarter decisions aligning with organisational values.",
      descBullets: [
        "Tech Stack: .NET 8, Phi-4, Minimal API",
      ],
      images: [
        require("./assets/images/POCAI_3.png"),
        require("./assets/images/POCAI_1.png"),
        require("./assets/images/POCAI_2.png"),
      ],
      footerLink: []
    },
    {
      projectName: "Portland Travel and recommendation system",
      projectDesc: "A travel recommendation system that suggests Portland destinations using Python and Google Maps API, optimized with pathfinding algorithms.",
      descBullets: [
        "Tech Stack: Python, Google Maps API, Dijkstra's algorithms, Opeweather API, Tkinter for GUI",
      ],
      images: [
        require("./assets/images/portland_travel_ss.png"),
        require("./assets/images/portland_travel_time_complexity_analysis.png"),
        require("./assets/images/ptrs_1.png"),
      ],
      gitlink: "https://github.com/jaiminsavaliya316/Portland-travel-recomandation-system",
      footerLink: []
    },
    {
      projectName: "Time Layers",
      projectDesc: "Created a VR time machine that upgrades your cave into a condo and then into a cosmic penthouse.",
      descBullets: [
        "Tech Stack: Oculus SDK, Meta Quest 3, Unity3D, C#, Blender",
      ],
      images: [
        require("./assets/images/Past_time.png"),
        require("./assets/images/Present_time.png"),
        require("./assets/images/Future_time.png"),
        require("./assets/images/Time_clockes.png"),
      ],
      gitlink: "https://github.com/jaiminsavaliya316/TimeLayers",
      footerLink: []
    },
    {
      projectName: "Sign Language Detection System",
      projectDesc: "A computer vision-based system using TensorFlow and YOLO to detect and translate sign language gestures into text.",
      descBullets: [
        "Tech Stack: Python, TensorFlow, YOLO",
      ],
      images: [
        require("./assets/images/hello_op.png"),
        require("./assets/images/wait_op.png"),
      ],
      gitlink: "https://github.com/jaiminsavaliya316/Sign-Language-Detection-System",
      footerLink: []
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Introductory AI Literacy",
      image: require("./assets/images/Northeastern University (NU) - Introductory AI Literacy - 2024-04-08.png"),
      imageAlt: "Ai badge",
      footerLink: [
        {
          name: "Introductory AI Literacy",
          url: "https://badgr.com/public/assertions/ZU5eZYZyRPmrCi3R83-GFQ"
        }
      ]
    },
    {
      title: "Supervised Machine Learning",
      image: require("./assets/images/courseera ML certificate img.png"),
      imageAlt: "Ai badge",
      footerLink: [
        // {
        //   name: " Supervised Machine Learning",
        //   url: "https://badgr.com/public/assertions/ZU5eZYZyRPmrCi3R83-GFQ"
        // }
      ]
    },
    {
      title: "Design and analysis of Algorithms",
      image: require("./assets/images/DAA img.png"),
      imageAlt: "Ai badge",
      footerLink: [
        // {
        //   name: " Supervised Machine Learning",
        //   url: "https://badgr.com/public/assertions/ZU5eZYZyRPmrCi3R83-GFQ"
        // }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};


// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "savaliya.ja@northeastern.edu"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
